import React, { useCallback, useEffect, useState } from 'react'
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3'

/**
 * Wrapper na provider reCaptchy V3
 * @returns {JSX.Element} -  dzieci
 */
export const GoogleRecaptchaProviderWrapper = (props) => {
  const apiKey = data.google_captcha.api_key
  const active = data.google_captcha.active
  if (!apiKey) {
    alert('GoogleRecaptchaV3 missing apiKey')
    throw new Error('GoogleRecaptchaV3 missing apiKey')
  }
  if (active !== '1') { // Jeśli weryfikacja captcha wyłączona zwróć tylko dzieci
    return props.children
  }
  return (
    <GoogleReCaptchaProvider reCaptchaKey={apiKey}>
      {props.children}
    </GoogleReCaptchaProvider>
  )

}
/**
 *  Komponent generujący token reCaptcha V3 , musi być dzieckiem GoogleRecaptchaProviderWrapper
 * @param props.fieldName nazwa pola do którego ma być wstrzyknięty token weryfikacyjny
 * @param props.setFieldValue funkcja formika do ustawienia wartosci pola
 * @returns ''
 *
 */
export const GoogleRecaptchaV3 = (props) => {
  const active = data.google_captcha.active
  const interval = data.google_captcha.token_refresh_interval
  const { fieldName, setFieldValue} = props
  const [refreshCaptcha, setRefreshCaptcha] = useState(false)
  if (active !== '1') { // Jeśli weryfikacja captcha wylączona-nie wykonuj nic
    return ''
  }

  useEffect(() => {
    if (!refreshCaptcha) {
      const timeout = setTimeout(() => {
        setRefreshCaptcha(true)
      }, interval)
    }
  }, [refreshCaptcha])


  if (!fieldName || !setFieldValue) {
    alert('GoogleRecaptchaV3 missing params, check console')
    console.error('GoogleRecaptchaV3 params list fieldName, setFieldValue ', fieldName, typeof setFieldValue)
    throw new Error('GoogleRecaptchaV3 missing params')
  }
  const { executeRecaptcha } = useGoogleReCaptcha()

  // Create an event handler so you can call the verification
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available')
      return
    }
    let token
    if (refreshCaptcha) {
      token = await executeRecaptcha('reVerify')
      setRefreshCaptcha(false)
    } else {
      token = await executeRecaptcha('verify')
    }
    setFieldValue(fieldName, token)
  }, [executeRecaptcha, refreshCaptcha === true])

  useEffect(() => {
    handleReCaptchaVerify()
  }, [handleReCaptchaVerify])

  return ('')

}
export const handleCaptchaVerify = (token, fieldName, setFieldValue) => {
  if (token && fieldName && setFieldValue) {
    setFieldValue(fieldName, token)
  }
}



